

export const DEFAULT_IMAGES = {
  hero: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1600&auto=format&fit=crop",
  overview: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1200&auto=format&fit=crop",
  accent: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=800&auto=format&fit=crop",
};

/* Agriculture keeps its original photography since that content already exists */
const AGRI_IMAGES = {
  hero: "https://images.unsplash.com/photo-1614977645968-6db1d7798ac7?q=80&w=1073&auto=format&fit=crop",
  overview:
    "https://images.pexels.com/photos/20445169/pexels-photo-20445169.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
  accent:
    "https://images.pexels.com/photos/26762735/pexels-photo-26762735.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=800&w=1200",
};

export const SECTION_NAV = [
  { id: "overview", label: "Overview" },
  { id: "councils", label: "Councils" },
  { id: "publications", label: "Publications" },
  { id: "press", label: "Press" },
  { id: "events", label: "Events" },
];

/* ------------------------------- helpers ------------------------------- */

export function getInitials(name = "") {
  const clean = name.replace(/\b(?:Mr|Ms|Mrs|Dr|Prof|Capt|Col|Shri|Smt)\.?\s+/g, "").trim();
  const parts = clean.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/* Splits a council title into a two-line hero heading (2nd line gets the
   gradient accent treatment) without needing to hand-curate every entry. */
export function splitHeroTitle(title = "") {
  const words = title.split(" ");
  if (words.length <= 3) return { line1: title, line2: "" };
  const mid = Math.ceil(words.length / 2);
  return { line1: words.slice(0, mid).join(" "), line2: words.slice(mid).join(" ") };
}

/* Builds the `leadership` array CouncilLeadership expects from chair/coChairs.
   `photo` (agar diya ho) spread ke through automatically pass ho jata hai. */
function buildLeadership(chair, coChairs = []) {
  const list = [];
  if (chair)
    list.push({ ...chair, role: chair.role || "Council Chair", initials: getInitials(chair.name) });
  coChairs.forEach((c) =>
    list.push({ ...c, role: c.role || "Council Co-Chair", initials: getInitials(c.name) })
  );
  return list;
}

const PLACEHOLDER_OVERVIEW = (name) => [
  `Detailed overview content for the ${name} is being finalised by the secretariat and will be published on this page shortly.`,
  `In the meantime, reach out to the ASSOCHAM secretariat for this council's current mandate, leadership, and ongoing initiatives.`,
];

/* ============================================================
   SECTORS REGISTRY
============================================================ */

export const SECTORS = {
  /* ============================= AGRICULTURE & FOOD PROCESSING ============================= */

  "agri-industries-farming-practices": {
    sectorGroup: "Agriculture & Food Processing",
    title: "Agri Industries & Farming Practices Council",
    heroImage: AGRI_IMAGES.hero,
    overviewImage: AGRI_IMAGES.overview,
    accentImage: AGRI_IMAGES.accent,
    overview: [
      "ASSOCHAM, as India's Apex Chamber of Commerce, plays a significant role in advancing India's agriculture sector through both modern and traditional approaches.",
      "The Council of Agri Industries & Farming Practices functions as an Industry Policy Forum, bringing together key stakeholders, including the Ministry of Agriculture & Farmers' Welfare, Ministry of Fisheries, Animal Husbandry & Dairying, Ministry of Jal Shakti, Ministry of Chemicals & Fertilizers, SFAC, APEDA, NDDB, ICAR, CSIR, NCCD, MPEDA, and other leading institutions to deliberate on sectoral priorities, strengthen public policy dialogue, and recommend regulatory reforms that enhance productivity, sustainability, and business competitiveness.",
      "The Council's core functions include stakeholder collaboration, public policy advocacy, promotion of innovation, research and capacity-building programmes, and knowledge-sharing initiatives. Through exhibitions, conferences, workshops, training programmes, panel discussions, round-table meetings, and industry consultations, the Council promotes sustainable development, green growth, MSME growth, and the adoption of best practices.",
    ],
    leadership: buildLeadership(
      {
        name: "Jaidev R Shroff",
        designation: "Global CEO, UPL Limited",
        photo: "https://assocham.org/assets/images/sector_council/Jai-Shroff%20.jpg",
      },
      [
        {
          name: "N K Aggarwal",
          designation: "Chairman, Crystal Crop Protection Limited",
          photo:
            "https://assocham.org/assets/images/sector_council/1720685263_Mr.%20N%20K%20Aggarwal.png",
        },
      ]
    ),
    priorityAreas: [
      "Convene industry, government, research bodies and farmer organisations on one table",
      "Build evidence with knowledge partners into actionable position papers",
      "Advocate reform through memoranda, consultations and task forces",
      "Deploy pilots, training and technology down to the last farm",
    ],
    publications: [
    ],
    pressReleases: [
    ],
    pressCoverage: [
    ],
    events: [
    ],
  },

  "food-processing-value-addition": {
    sectorGroup: "Agriculture & Food Processing",
    title: "Food Processing & Value Addition Council",
    overview: [
      "India's food processing sector converts a growing share of agricultural output into safer, longer-shelf-life and export-ready products, cutting post-harvest losses while adding value across the farm-to-fork chain.",
      "The ASSOCHAM Food Processing & Value Addition Council brings together processors, cold-chain and packaging companies, and branded-food businesses to engage the Ministry of Food Processing Industries on mega food parks, PLI-linked capacity expansion, food safety standards and export competitiveness.",
    ],
    leadership: buildLeadership(
      { name: "Vivek Chandra", designation: "CEO – Global Branded Business, LT Foods", photo: "" },
      [{ name: "Vikram Kelkar", designation: "Managing Director, Hexagon Nutrition Limited", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= GREEN MOBILITY & AUTOMOTIVE ============================= */

  "auto-auto-ancillaries": {
    sectorGroup: "Green Mobility and Automotive & Auto Components",
    title: "Auto & Auto Ancillaries Council",
    overview: [
      "India's automotive industry is one of the strongest pillars of the country's industrial growth, contributing over 7% to national GDP, nearly 22% of manufacturing GDP, and 7–8% of total employment.",
      "The ASSOCHAM National Council on Auto & Auto Ancillaries serves as an Industry Policy Forum, bringing together industry leaders, policymakers, and key stakeholders to promote regulatory reforms and holistic development of the sector.",
      "The Council focuses on sustainable development, green growth, infrastructure development, business competitiveness, export promotion and global trade, while strengthening India's position as a leading global automotive manufacturing hub.",
    ],
    leadership: buildLeadership(
      { name: "Sunil Kakkar", designation: "Whole Time Director & Executive Committee Member, Maruti Suzuki India Private Limited", photo: "" },
      [{ name: "Ms. Mandhira Kapur Smith", designation: "Founder & CMD, SMIC Autoparts", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "green-mobility": {
    sectorGroup: "Green Mobility and Automotive & Auto Components",
    title: "Green Mobility Council",
    overview: [
      "As India accelerates its shift to cleaner transport, green mobility has emerged as a strategic pillar spanning electric vehicles, charging infrastructure, battery technology and low-carbon fuels.",
      "The ASSOCHAM Green Mobility Council convenes OEMs, battery and component manufacturers, and policymakers to advance EV adoption, charging-infrastructure rollout, PLI-linked battery manufacturing and the broader transition toward sustainable transportation.",
    ],
    leadership: buildLeadership(
      { name: "Nishant Arya", designation: "Vice Chairman, JBM Group", photo: "" },
      [{ name: "Vikram Handa", designation: "Vice Chairman, Epsilon Carbon Pvt Ltd.", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= MSME ============================= */

  "msme-development-council": {
    sectorGroup: "MSME",
    title: "MSME Development Council",
    overview: [
      "MSME Growth is a key pillar of the vision of Viksit Bharat 2047. As the backbone of the Indian economy, MSMEs play a vital role in driving employment, entrepreneurship, business competitiveness, exports, and inclusive economic growth.",
      "ASSOCHAM's National Council on MSMEs is an Industry Policy Forum dedicated to promoting Ease of Doing Business, public policy advocacy, innovation, and sustainable MSME growth, regularly engaging with government bodies, financial institutions, and industry members.",
      "The Council organises sector-specific summits, conferences, and stakeholder consultations, and annually recognises outstanding achievement through the MSME National Excellence Awards, Service Excellence Awards, and the MSME Expo.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Munish Sharda", designation: "Executive Director, Axis Bank", photo: "" },
      [
        { name: "Mr. Dev P. Goel", designation: "Managing Director, Madhu Group", photo: "" },
        { name: "Mr. Puran Dawar", designation: "Chairman, Dawar Footwear Industries", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= EDSM ============================= */

  "electronics-components": {
    sectorGroup: "Electronic Device & Semiconductor Manufacturing (EDSM)",
    title: "Electronics & Components Council",
    overview: [
      "ASSOCHAM established the Electronics & Components Council to facilitate stakeholder, industry, and government engagement toward making India a global electronics manufacturing hub.",
      "The Council targets IT hardware and mobile devices, consumer electronics and durables, industrial electronics, telecom equipment, auto electronics, components, medical electronics, and defence electronics, providing a platform for smooth and transparent policy dialogue.",
      "It discusses policy with stakeholders and industry experts to recommend measures that promote investment and opportunity across the sector.",
    ],
    leadership: buildLeadership(
      { name: "Col. Ali Jafri", designation: "Sr. Director, Dell", photo: "" },
      [
        { name: "Mr. K P Sharma", designation: "Vice President, Schneider Electric", photo: "" },
        { name: "Mr. Kulin Sanghvi", designation: "Head Govt. Affairs, Apple", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= PHARMA, MED-TECH & HEALTHCARE ============================= */

  "pharmaceuticals": {
    sectorGroup: "Pharma, Med-tech & Healthcare",
    title: "Pharmaceuticals Council",
    overview: [
      "Ranked third globally by volume, India's pharmaceutical sector is valued at approximately US$60.32 billion (2026), making it one of the country's most significant contributors to the economy, healthcare, and global pharmaceutical supply chains.",
      "The ASSOCHAM National Council for Pharmaceuticals is an Industry Policy Forum bringing together industry leaders, government bodies, policymakers, regulators, and researchers to address key sectoral challenges and advance the interests of India's pharma and biotech industries.",
      "As a strategic pillar of Make in India and Atmanirbhar Bharat, the sector strengthens India's healthcare ecosystem, research and innovation, global competitiveness, and sustainable economic development.",
    ],
    leadership: buildLeadership(
      { name: "Mr Ishteyaque Amjad", designation: "Managing Director - Policy & Global Govt. Affairs South Asia, ABBOTT", photo: "" },
      [{ name: "Mr. Nakul Verma", designation: "Sr. Director, Public Policy, Sanofi", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "med-tech-devices": {
    sectorGroup: "Pharma, Med-tech & Healthcare",
    title: "Med-Tech Council",
    overview: [
      "The ASSOCHAM Council on Med-Tech is an Industry Policy Forum bringing together industry leaders, policymakers, regulators, and healthcare experts to deliberate on key sectoral issues and advocate reforms that strengthen India's MedTech ecosystem.",
      "The Council promotes Ease of Doing Business, business competitiveness, industry collaboration, innovation, and sustainable growth on behalf of ASSOCHAM's member organisations.",
      "Through stakeholder consultations, conferences, and policy dialogue, it helps members in medical devices and diagnostics engage constructively with government, academia, and industry.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Atul Grover", designation: "MD, BD & Co.", photo: "" },
      [
        { name: "Mr. Aditya Kohli", designation: "Director, External Affairs and Partnerships - SoA, Allied Medical Ltd", photo: "" },
        { name: "Mr. Sanjay Singh", designation: "Lead-Govt. Affairs, Roche Diagnostic India", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "healthcare-wellness": {
    sectorGroup: "Pharma, Med-tech & Healthcare",
    title: "Healthcare & Wellness Council",
    overview: [
      "The vision of Viksit Bharat 2047 can be realised through a robust, resilient, future-ready healthcare ecosystem that ensures accessible, affordable, quality healthcare for all.",
      "The ASSOCHAM Healthcare Council strengthens collaboration between government, industry, healthcare institutions and other stakeholders, supporting public policy, infrastructure development, and healthcare-workforce upskilling.",
      "It brings together the Ministry of Health & Family Welfare, PHFI, ICMR, public and private healthcare providers, PHCs, insurance companies, and other stakeholders across the ecosystem.",
    ],
    leadership: buildLeadership(
      { name: "Dr. Upasana Arora", designation: "Yashoda Hospital", photo: "" },
      [
        { name: "Dr. DK Gupta", designation: "CMD, Felix Hospital", photo: "" },
        { name: "Mr. Sandeep Verma", designation: "Country Head, India – Consumer Health, Bayer Consumers", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= POWER & ENERGY ============================= */

  "hydropower-psp": {
    sectorGroup: "Power & Energy (including Renewable Energy, Hydro/PSP, Thermal & Nuclear)",
    title: "Hydropower & PSP Council",
    overview: [
      "The ASSOCHAM National Council on Hydropower & Pumped Storage Projects (PSP) brings together public and private developers of large hydropower projects, PSPs, OEMs, and technology providers across the hydropower value chain.",
      "For over a decade the Council has strengthened India's hydropower ecosystem through policy advocacy, helping transform hydropower into a national renewable and clean-energy priority — contributing to the Union Cabinet's National Hydropower Policy (2019) and the Hydropower Purchase Obligation trajectory (2021).",
      "In 2025, ASSOCHAM became the only industry chamber represented on the CEA Sub-Committees assessing normative costs of enabling infrastructure for hydropower and PSP developers.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Naresh Telgu", designation: "COO, Adani Hydro", photo: "" },
      [
        { name: "Mr. P M Nanda", designation: "Executive Vice President, Greenko Group", photo: "" },
        { name: "Mr. Vivek Srivastava", designation: "Consultant, Torrent Power", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "power-generation": {
    sectorGroup: "Power & Energy (including Renewable Energy, Hydro/PSP, Thermal & Nuclear)",
    title: "Power Generation Council",
    overview: [
      "The ASSOCHAM National Council on Power brings together thermal power generators (IPPs and CPPs), transmission developers, distribution utilities, and OEMs across India's power value chain.",
      "As energy demand grows, conventional thermal power remains critical for baseload generation, energy security, and grid stability, even as the sector transitions to cleaner, more efficient technologies for India's Net Zero goals.",
      "The Council engages regularly with the Union Minister for Power, Secretary Power, CEA and CERC leadership, and makes policy submissions on the Electricity Amendment Bill, generation reforms, and DISCOM performance.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Sanjeev Seth", designation: "MD & CEO, ITPCL", photo: "" },
      [{ name: "Mr. Lalit Jain", designation: "President Thermal, HPPPL", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "power-distribution": {
    sectorGroup: "Power & Energy (including Renewable Energy, Hydro/PSP, Thermal & Nuclear)",
    title: "Power Distribution Council",
    overview: [
      "The ASSOCHAM National Council on Power provides a unified industry voice across generation, transmission and distribution, working with the Central and State Governments, regulators, and PSUs.",
      "On distribution, the Council's priorities include improving the operational and financial performance of DISCOMs and reducing Aggregate Technical & Commercial (AT&C) losses.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Chetan Bundela", designation: "Executive Director, Torrent Power", photo: "" }
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "power-transmission": {
    sectorGroup: "Power & Energy (including Renewable Energy, Hydro/PSP, Thermal & Nuclear)",
    title: "Power Transmission Council",
    overview: [
      "The ASSOCHAM National Council on Power has undertaken industry-led studies assessing the adequacy of planned transmission infrastructure to support conventional generation alongside rapid renewable-energy expansion.",
      "The Council also tracks on-ground transmission development and flags challenges that could affect timely project commissioning, feeding policy representations to Government.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Manish Agrawal", designation: "MD & CEO, Apar Group", photo: "" },
      [
        { name: "Mr. Balaji Sivan", designation: "Head Regulatory Affairs, GR Infra", photo: "" },
        { name: "Mr. Prashant Sinha", designation: "COO, Sterlite Power Transmission", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "renewable-energy": {
    sectorGroup: "Power & Energy (including Renewable Energy, Hydro/PSP, Thermal & Nuclear)",
    title: "New & Renewable Energy Council",
    overview: [
      "The ASSOCHAM National Council on New and Renewable Energy brings together developers, manufacturers and generators across the solar and wind sectors, contributing to India's target of 500 GW of renewable capacity by 2030.",
      "Its study 'Supporting an ecosystem for development of Indian solar and equipment manufacturing' recommended ALMM, BCD, and PLI schemes, and a phase-wise local value-addition target of 75–85%.",
      "The Council also supports grid integration, energy storage, the Statewise Solar Rooftop Attractiveness Index (SARAL — adopted by MNRE), and Green Hydrogen ecosystem development.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Ashish Khanna", designation: "CEO, Adani Green Energy Ltd.", photo: "" },
      [{ name: "Mr. Prashant Choubey", designation: "President & Head Green Hydrogen Business, Avaada", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= IT/ITeS ============================= */

  "animation-visual-effects-gaming-comics-avgc": {
    sectorGroup: "IT/ITeS (including Digital Tech/Fintech)",
    title: "AVGC Council",
    overview: [
      "The Animation, Visual Effects, Gaming, and Comics (AVGC) sector is becoming a key driver of India's creative economy. ASSOCHAM's AVGC Council brings together industry leaders, policymakers, technology enablers and creators to accelerate its growth.",
      "Aligned with Digital India and Viksit Bharat 2047, the Council promotes innovation, skill development, investment opportunities, and industry-led initiatives that position India as a global AVGC hub.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Shailendra Jha", designation: "Director, YouTube (Google)", photo: "" },
      [{ name: "Mr. Ravi Jha", designation: "Director, Zupee", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "cyber-security-cyber-law": {
    sectorGroup: "IT/ITeS (including Digital Tech/Fintech)",
    title: "Cyber Security & Cyber Law Council",
    overview: [
      "The ASSOCHAM National Council on Cyber Security & Cyber Law brings together industry leaders, policymakers, regulators, and academia to strengthen cyber resilience and public policy dialogue.",
      "The Council works with the Council of Europe, Strasbourg, and runs the Annual Summit on Cyber & Network Security, officially supported by MeitY, alongside its flagship summits INDISEC and CySecCon.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Sandeep Aurora", designation: "Director, Microsoft", photo: "" },
      [{ name: "Mr. Vikram Sridharan", designation: "Director, AWS", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "data-centre": {
    sectorGroup: "IT/ITeS (including Digital Tech/Fintech)",
    title: "Data Centre Council",
    overview: [
      "Data centres are increasingly critical to India's digital economy. The ASSOCHAM Data Centre Council is a platform for industry leaders, policymakers, and cloud service providers to deliberate on India's data centre and cloud ecosystem.",
      "The Council promotes regulatory reforms, foreign investment, and policy initiatives that position India as a globally competitive data centre hub.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Sunil Gupta", designation: "Co-Founder and CEO, Yotta", photo: "" },
      [
        { name: "Mr. Manoj Paul", designation: "CEO, Equinix", photo: "" },
        { name: "Mr. Samir Vora", designation: "CEO India, Adani Connex", photo: "" },
        { name: "Mr. Surajit Chatterjee", designation: "MD, Capitaland", photo: "" },
        { name: "Mr. Suresh Rathod", designation: "President, Co-location Business, CtrlS Datacenters Ltd", photo: "" },
        { name: "Mr. Sharad Agarwal", designation: "CEO Data Center, Sify", photo: "" },
        { name: "Mr. Jatinder Singh Pabla", designation: "Chief Sales & Marketing Officer, STT Global Data Centers India Pvt. Ltd", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "digital-communication": {
    sectorGroup: "IT/ITeS (including Digital Tech/Fintech)",
    title: "Digital Communication Council",
    overview: [
      "The ASSOCHAM Digital Communication Council brings together stakeholders, policymakers and regulators to promote Ease of Doing Business, infrastructure development, and regulatory reforms across digital communications.",
      "Focus areas include telecom-sector financial health, common telecom infrastructure, Right of Way rules, spectrum management, 5G, IoT/M2M, cybersecurity, and OTT frameworks. The Council contributed to the National Digital Communications Policy, 2018.",
    ],
    leadership: buildLeadership(
      { name: "Dr. Ravi Gandhi", designation: "President, RIL", photo: "" },
      [
        { name: "Mr. Manoj Kumar Misra", designation: "Chief Corporate Affairs Officer, Indus Tower", photo: "" },
        { name: "Ms. Ambika Khurana", designation: "Chief Regulatory, CSR & External Communications, Vodafone", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "it-ites-digital-commerce": {
    sectorGroup: "IT/ITeS (including Digital Tech/Fintech)",
    title: "IT, ITeS & Digital Commerce Council",
    overview: [
      "The ASSOCHAM IT, ITeS & Digital Commerce Council drives dialogue on AI, Blockchain, Robotics and other digital innovations in support of Digital India and Viksit Bharat 2047.",
      "It works with MeitY, the Ministry of Science & Technology, Commerce & Industry, MSME, and NITI Aayog to promote entrepreneurship, Startup India, and emerging-technology adoption, and collaborates with other councils on Industry 4.0, smart cities and digital infrastructure.",
    ],
    leadership: buildLeadership(
      { name: "Dr. Lovneesh Chanana", designation: "Sr. VP, SAP", photo: "" },
      [
        { name: "Dr. Ravi Gandhi", designation: "President, RIL", photo: "" },
        { name: "Mr. Sunil Abraham", designation: "Director Public Policy, Facebook India Online Services Pvt Ltd", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "fintech": {
    sectorGroup: "IT/ITeS (including Digital Tech/Fintech)",
    title: "Fintech Council",
    overview: [
      "Since the pandemic, India's fintech ecosystem has grown rapidly across digital payments, lending, wealth management and investment advisory.",
      "The ASSOCHAM Fintech Council promotes regulatory reforms, Ease of Doing Business, and responsible fintech adoption through collaboration between industry, government, regulators and financial institutions.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Gautam Aggarwal", designation: "MD, Master Card", photo: "" },
      [
        { name: "Mr. Madhur Deora", designation: "President, Paytm", photo: "" },
        { name: "Mr. Sabyasachi Goswami", designation: "CEO, Perfios", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= BFSI ============================= */

  "banking": {
    sectorGroup: "Banking, Financial Services & Insurance (BFSI)",
    title: "Banking Council",
    overview: [
      "The ASSOCHAM National Council on Banking addresses key challenges across banking and financial services, strengthening collaboration between industry, regulators, and policymakers.",
      "Key stakeholders include the RBI, Ministry of Finance, World Bank, IFC, IFSCA, NABARD, SIDBI, NHB, RRBs and Co-operative Banks. The Council runs regular meetings, webinars, summits and round-tables.",
    ],
    leadership: buildLeadership(
      { name: "Mr. P R Seshadri", designation: "MD and CEO, South Indian Bank", photo: "" },
      [
        { name: "Mr. Rajan Pental", designation: "Executive Director, Yes Bank Ltd.", photo: "" },
        { name: "Mr. Madhav Nair", designation: "Country Head & CEO - India, Bank of Bahrain and Kuwait B.S.C.", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "capital-markets": {
    sectorGroup: "Banking, Financial Services & Insurance (BFSI)",
    title: "Capital Markets Council",
    overview: [
      "Capital markets provide the financial resources essential for India's long-term growth. The ASSOCHAM Council for Capital & Commodity Markets works with Government, regulators and market participants to promote reforms and investor awareness.",
      "Through conferences and stakeholder consultations, the Council improves financial literacy and encourages greater participation in capital markets.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Luv Chaturvedi", designation: "ED & CEO, IndusInd Securities Ltd.", photo: "" },
      [
        { name: "Mr. Sandeep Bhardwaj", designation: "CEO, PayTm Money", photo: "" },
        { name: "Mr. Jayprakash Gupta", designation: "Founder, Raise Financial Services", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "commodity-markets-investments": {
    sectorGroup: "Banking, Financial Services & Insurance (BFSI)",
    title: "Commodity Markets & Investments Council",
    overview: [
      "The ASSOCHAM Council for Capital & Commodity Markets promotes regulatory reforms and new opportunities across India's commodity markets, strengthening public confidence in corporate securities and investment practices.",
    ],
    leadership: buildLeadership(
      { name: "Mr. S K Jindal", designation: "MD, Jindal Exports and Imports", photo: "" },
      [{ name: "Mr. Suvankar Sen", designation: "MD & CEO, Senco Gold Ltd.", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "corporate-bond-market": {
    sectorGroup: "Banking, Financial Services & Insurance (BFSI)",
    title: "Corporate Bond Market Council",
    overview: [
      "India's real sector, particularly NBFCs, still relies heavily on bank financing over corporate bonds. Achieving Viksit Bharat 2047 requires a deeper, more vibrant corporate bond market.",
      "The ASSOCHAM National Council for Corporate Bond Market works with SEBI, RBI and the Ministry of Finance through meetings, summits, and research initiatives to support a transparent, globally competitive bond market.",
    ],
    leadership: buildLeadership(
      { name: "Ms. Nipa Sheth", designation: "Founder & Director, Trust Group", photo: "" },
      [
        { name: "Mr. P K Malhotra", designation: "MD & CEO, IDBI Trusteeship Ltd", photo: "" },
        { name: "Ms. Aditi Mittal", designation: "Director, A K Capital Services Ltd", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "insurance": {
    sectorGroup: "Banking, Financial Services & Insurance (BFSI)",
    title: "Insurance Council",
    overview: [
      "The insurance sector safeguards individuals, businesses and assets against financial risk, strengthening economic resilience and long-term capital formation.",
      "The ASSOCHAM National Council for Insurance works closely with IRDAI, the Ministry of Finance, and insurance companies to deliberate on regulatory reforms and support a robust, inclusive insurance ecosystem.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Anuj Mathur", designation: "MD & CEO, Canara HSBC Life", photo: "" },
      [
        { name: "Mr. Rajiv Gupta", designation: "President, PB Fintech Ltd", photo: "" },
        { name: "Ms. Girija Subramanium", designation: "CMD, New India Assurance", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "nbfcs-green-financing": {
    sectorGroup: "Banking, Financial Services & Insurance (BFSI)",
    title: "NBFCs & Green Financing Council",
    overview: [
      "Non-Banking Financial Companies have become a critical last-mile channel for credit to MSMEs, retail borrowers and underserved segments, while green financing is emerging as the backbone of India's climate-transition investments.",
      "The ASSOCHAM Council on NBFCs & Green Financing works with the RBI and Ministry of Finance to strengthen NBFC regulatory frameworks and expand sustainable-finance instruments that channel capital toward renewable energy, climate resilience and inclusive growth.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Shachindra Nath", designation: "VC & MD, U GRO Capital Ltd.", photo: "" },
      [{ name: "Mr. Sadaf Sayeed", designation: "CEO, Muthoot MicroFin Ltd.", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "stressed-assets": {
    sectorGroup: "Banking, Financial Services & Insurance (BFSI)",
    title: "Stressed Assets Council",
    overview: [
      "A faster, fairer resolution ecosystem for stressed assets is central to financial-sector stability, credit discipline and investor confidence in India.",
      "The ASSOCHAM Stressed Assets Council brings together Asset Reconstruction Companies, banks, NBFCs, investors and legal experts to engage the RBI, Ministry of Finance and IBBI on insolvency reforms and more efficient resolution mechanisms under the IBC framework.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Pradeep Goel", designation: "MD, Prudent ARC Ltd.", photo: "" },
      [
        { name: "Mr. Phanindranath Kakarla", designation: "MD & CEO, Asset Reconstruction Company (India) Limited (ARCIL)", photo: "" },
        { name: "Mr. Bahram N. Vakil", designation: "Founder & Senior Partner, AZB & Partners", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "cfos": {
    sectorGroup: "Banking, Financial Services & Insurance (BFSI)",
    title: "CFO Council",
    overview: [
      "As India's economy evolves, the role of CFOs has expanded beyond financial management to strategic decision-making, business competitiveness, and long-term value creation.",
      "The ASSOCHAM Council for CFOs brings together CFOs, industry leaders, policymakers and regulators to deliberate on regulatory reforms, governance frameworks, and government initiatives.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Ajay Bagri", designation: "CFO, SEIL Energy India Ltd", photo: "" },
      [{ name: "Dr. Chanchal Singh Satyandra Rajora", designation: "CFO, Transformers & Rectifiers (India) Ltd", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= EDUCATION & SKILLING ============================= */

  "national-council-on-education": {
    sectorGroup: "Education & Skilling",
    title: "National Council on Education",
    overview: [
      "Viksit Bharat 2047 recognises education, innovation and skill development as key catalysts for India's knowledge-driven economy.",
      "The ASSOCHAM National Council on Education brings together government, academicians, think tanks and industry leaders to deliberate on education policy, institutional development, and sectoral priorities — including the National Education Policy (NEP) and NAAC reforms.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Kunwar Shekhar Vijendra", designation: "Co-Founder & Chancellor, Shobhit University", photo: "" },
      [
        { name: "Dr. Madhu Chitkara", designation: "Pro-Chancellor, Chitkara University", photo: "" },
        { name: "Prof. Rajita Kulkarni", designation: "President, Sri Sri University", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= TAXATION ============================= */

  "direct-taxes": {
    sectorGroup: "Taxation - Direct / Indirect",
    title: "Direct Taxes Council",
    overview: [
      "A stable, predictable direct-tax regime underpins investor confidence and long-term business planning across India's economy.",
      "The ASSOCHAM Direct Taxes Council engages the Ministry of Finance and CBDT through pre-budget and post-budget memoranda, policy representations and expert consultations on direct-tax reforms, compliance simplification and dispute resolution.",
    ],
    // NOTE: the master sheet lists the Chair as "Mr. Sandeep Chaufla / Mr. Ved Jain (recommended)" —
    // not yet finalised. Using Mr. Sandeep Chaufla below; confirm with the secretariat and update if needed.
    leadership: buildLeadership(
      { name: "Mr. Sandeep Chaufla", designation: "Partner, Price Waterhouse & Co LLP (PwC)", photo: "" },
      [{ name: "Mr. Vineet Agrawal", designation: "Sr. EVP and Group Head (Taxation & Ethics), JSW Group", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "indirect-taxes": {
    sectorGroup: "Taxation - Direct / Indirect",
    title: "Indirect Taxes Council",
    overview: [
      "The ASSOCHAM Council for Indirect Taxes contributes to a business-friendly tax environment, partnering with industry and government to bridge policymaking, interpretation and implementation.",
      "ASSOCHAM created VAT awareness through 25 conferences and 4 knowledge papers, and during GST rollout conducted 150+ sessions nationwide, including 75 training and awareness programmes.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Pratik Jain", designation: "Partner, Price Waterhouse & Co LLP (PwC)", photo: "" },
      [{ name: "Mr. Nitin Goyal", designation: "Sr. VP and Group Head - Indirect Tax, Welspun", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= LOGISTICS & WAREHOUSING ============================= */

  "logistics-and-warehousing": {
    sectorGroup: "Logistics & Warehousing",
    title: "National Council on Logistics and Warehousing",
    overview: [
      "The Council brings together logistics service providers, warehousing companies, infrastructure developers, technology enablers and policymakers to strengthen India's logistics and supply chain ecosystem.",
      "It addresses operational inefficiencies and engages Government on initiatives like the e-Logs portal, working toward a resilient, integrated, technology-driven logistics ecosystem.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Sandeep Wadhwa", designation: "Group Director, JM Baxi", photo: "" },
      [
        { name: "Mr. Vipin Vohra", designation: "Chairman, Continental Carriers", photo: "" },
        { name: "Mr. Sukanta Das", designation: "CLO & President, Hindalco, Aditya Birla Group", photo: "" },
        { name: "Mr. Sanjay Bajpai", role: "Industry Veteran & Advisor", designation: "Former Executive Director, CONCOR", photo: "" },
      ]
    ),
    priorityAreas: [
      "Multimodal logistics and seamless connectivity",
      "Digital transformation and adoption of emerging technologies",
      "Warehousing infrastructure development and standardisation",
      "Regulatory simplification and Ease of Doing Business",
      "Reducing logistics costs and improving operational efficiency",
      "Sustainability and green logistics practices",
    ],
    publications: [], pressReleases: [], pressCoverage: [],
    events: [
      { title: "Architectural Meet", type: "forthcoming", tag: "Meet", date: "June 2026", place: "To be announced", text: "Forthcoming engagement of the National Council on Logistics and Warehousing.", highlight: "" },
      { title: "Conference on Cold Chain", type: "forthcoming", tag: "Conference", date: "September 2026", place: "To be announced", text: "Forthcoming conference on cold-chain infrastructure and practices.", highlight: "" },
      { title: "Logistics Awards", type: "forthcoming", tag: "Awards", date: "November 2026", place: "To be announced", text: "Annual recognition of excellence across India's logistics and warehousing sector.", highlight: "" },
    ],
  },

  /* ============================= LEGAL & CORPORATE AFFAIRS ============================= */

  "corporate-affairs-company-law-corporate-governance": {
    sectorGroup: "Legal & Corporate Affairs",
    title: "Corporate Affairs, Company Law & Corporate Governance Council",
    overview: [
      "Corporate governance has emerged as a critical global framework for protecting stakeholder and shareholder interests through transparency, accountability and disclosure.",
      "The ASSOCHAM Council works with the Ministry of Corporate Affairs on policy recommendations and amendments to the Companies Act, 2013, and engages SEBI, ICAI, ICMAI and ICSI on governance and compliance.",
    ],
    leadership: buildLeadership(
      { name: "Ms. Preeti Malhotra", designation: "Chairman, Smart Bharat Group", photo: "" },
      [{ name: "Mr. Rajesh Arora", designation: "Partner, B S R & Co. LLP (KPMG)", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "intellectual-property-rights": {
    sectorGroup: "Legal & Corporate Affairs",
    title: "Intellectual Property Rights (IPR) Council",
    overview: [
      "The ASSOCHAM IPR Council advances protection, promotion and enforcement of intellectual property rights in India, strengthening awareness and innovation-friendly policy frameworks.",
      "Under the Council, the ASSOCHAM Intellectual Property Facilitation Centre (AIPFC) helps MSMEs identify, protect, commercialise and manage IP assets through training, advisory and capacity-building programmes.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Pravin Anand", designation: "Managing Partner, Anand & Anand", photo: "" },
      [{ name: "Ms. Manisha Singh", designation: "Managing Partner, Lexorbis", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "legal-affairs-regulatory-reforms": {
    sectorGroup: "Legal & Corporate Affairs",
    title: "Legal Affairs & Regulatory Reforms Council",
    overview: [
      "A responsive legal and regulatory environment is essential to Ease of Doing Business and long-term investor confidence in India.",
      "The ASSOCHAM Legal Affairs & Regulatory Reforms Council brings together senior legal practitioners and industry leaders to engage government and regulators on legal-reform priorities, regulatory simplification and dispute-resolution frameworks.",
    ],
    // NOTE: the master sheet lists the 3rd leadership seat as "Mr. Sanjeev K Kapoor / Mr. RK Handoo (wef 1.04)" —
    // not yet finalised. Using Mr. Sanjeev K Kapoor below; confirm with the secretariat and update if needed.
    leadership: buildLeadership(
      { name: "Mr. Suman Jyoti Khaitan", designation: "Senior Partner, AZB & Partners", photo: "" },
      [
        { name: "Mr. Hardeep Sachdeva", designation: "Sr. Partner, AZB & Partners", photo: "" },
        { name: "Mr. Sanjeev K Kapoor", designation: "Senior Partner, Khaitan and Co", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= INFRASTRUCTURE ============================= */

  "civil-aviation": {
    sectorGroup: "Infrastructure (Port, Shipping and Waterways, Task Force)",
    title: "Civil Aviation Council",
    overview: [
      "India's civil aviation sector is expanding rapidly on the back of enhanced air connectivity, world-class airport infrastructure, and sustainable aviation growth.",
      "The ASSOCHAM National Council on Civil Aviation brings together airlines, airport operators, MROs, OEMs, service providers, policymakers and regulators to recommend policy and regulatory reforms.",
    ],
    leadership: buildLeadership(
      { name: "Mr. P Balaji", designation: "Group Head Corporate Affairs, Air India", photo: "" },
      [
        { name: "Mr. Animesh Bhatt", designation: "Chief Airport Officer, Adani Airport Holding Ltd.", photo: "" },
        { name: "Mr. Manomay Rai", designation: "Dy CEO, Delhi Airport, GMR Airports Limited (GMR Group)", photo: "" },
        { name: "Mr. Ashish Saraf", designation: "VP and Country Head, Pratt and Whitney (United Technologies Corporation India Pvt Ltd)", photo: "" },
      ]
    ),
    priorityAreas: [
      "Make in India & Aviation Ecosystem — domestic MRO and component manufacturing",
      "Policy reforms — regulatory simplification and investment facilitation",
      "Infrastructure & connectivity development — airport expansion and regional connectivity",
      "Sustainable aviation growth — green airports and sustainable aviation fuel (SAF)",
      "Enhancing air connectivity through UDAN and aviation hubs",
      "Air cargo & logistics development",
    ],
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "highway-tunnel-infrastructure": {
    sectorGroup: "Infrastructure (Port, Shipping and Waterways, Task Force)",
    title: "National Council on Highways & Tunneling",
    overview: [
      "For over a decade the Council has driven policy and regulatory reforms to improve safety, efficiency, cost-effectiveness and timely delivery, working with MoRTH, NHAI, NHIDCL and BRO.",
      "Its recommendations on the Zojila Tunnel Project contributed to a revised tendering framework that reduced project cost from nearly ₹11,000 crore to about ₹6,000 crore — publicly acknowledged by the Union Minister for Road Transport & Highways.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Ashutosh Chandwar", designation: "COO, DRAIPL", photo: "" },
      [
        { name: "Mr. Ajendra Agarwal", designation: "MD, G R Infra", photo: "" },
        { name: "Mr. Harpal Singh", designation: "Jt. COO, Megha Engineering Ltd", photo: "" },
        { name: "Mr. Sharad Kumar", designation: "Executive Vice President, Patel Engg.", photo: "" },
      ]
    ),
    priorityAreas: [
      "Resilient infrastructure & safety through stronger engineering standards",
      "Policy & regulatory reforms in procurement, contracts and dispute resolution",
      "Technology & innovation — BIM, AI-driven project management, digital engineering",
    ],
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "railways-council": {
    sectorGroup: "Infrastructure (Port, Shipping and Waterways, Task Force)",
    title: "National Council on Railways",
    overview: [
      "The Council convenes Indian Railways, rolling stock manufacturers, technology providers, logistics companies and infrastructure developers to promote reforms and unlock investment across India's rail ecosystem.",
      "It supports the modernisation agenda of Indian Railways, identifying implementation challenges and promoting sustainable development and digital transformation.",
    ],
    leadership: [
      { name: "Mr. Vivek Lohia", role: "Chairman", designation: "Managing Director, Jupiter Wagons Ltd", initials: getInitials("Mr. Vivek Lohia"), photo: "" },
      { name: "Mr. Sushil Nowal", role: "Co-Chairman", designation: "Executive Vice President, JSW Steel Ltd.", initials: getInitials("Mr. Sushil Nowal"), photo: "" },
      { name: "Mr. Sanjay Bajpai", role: "Industry Veteran & Advisor", designation: "Former Executive Director, CONCOR", initials: getInitials("Mr. Sanjay Bajpai"), photo: "" },
    ],
    priorityAreas: [
      "Rail infrastructure development and capacity augmentation",
      "Private sector participation and PPP models",
      "Adoption of advanced technologies and digital systems",
      "Freight movement and multimodal integration",
      "Indigenous manufacturing and Make in India initiatives",
    ],
    publications: [], pressReleases: [], pressCoverage: [],
    events: [
      { title: "Railtech", type: "forthcoming", tag: "Conference", date: "January 2027", place: "To be announced", text: "Forthcoming flagship engagement of the National Council on Railways.", highlight: "" },
    ],
  },

  /* ============================= SUSTAINABILITY & ENVIRONMENT ============================= */

  "sustainability-environment": {
    sectorGroup: "Sustainability & Environment (including Water / GEM)",
    title: "Sustainability & Environment Council",
    overview: [
      "The ASSOCHAM National Council on Sustainability & Environment is the Chamber's flagship platform for advancing sustainable industrial growth and India's transition to a net-zero, climate-resilient future.",
      "It drives policy advocacy and capacity building across seven verticals: Climate & Net Zero, Circular Economy & Resource Efficiency, Water Stewardship, ESG & Responsible Business, Sustainable Cities, Biodiversity & Natural Capital, and Clean Energy & Green Technology.",
      "The Council advances its mission through ASSOCHAM's 4A Approach — Advocate, Align, Accelerate, Advance — and anchors two flagship platforms: the National Council on Water and the GEM Green Building Certification Programme.",
    ],
    leadership: [
      { name: "Dr. Angelo George", role: "Chairman", designation: "Chief Executive Officer, Bisleri International Private Limited", initials: getInitials("Dr. Angelo George"), photo: "" },
      { name: "Dr. Nidhi Pundhir", role: "Co-Chairman", designation: "VP & Head - HCL Foundation, HCL Technologies", initials: getInitials("Dr. Nidhi Pundhir"), photo: "" },
      { name: "Mr. Sandeep Chandna", role: "Co-Chairman", designation: "Chief Sustainability Officer, Tech Mahindra", initials: getInitials("Mr. Sandeep Chandna"), photo: "" },
    ],
    publications: [], pressReleases: [], pressCoverage: [],
    events: [
      { title: "Roundtable on Advancing Clean Air Solutions", type: "past", tag: "Roundtable", date: "2025", place: "New Delhi", text: "Strategies for enabling a clean construction transition, held with the India Alliance for Clean Construction (IACC).", highlight: "" },
    ],
  },

  "water": {
    sectorGroup: "Sustainability & Environment (including Water / GEM)",
    title: "Water Council",
    overview: [
      "The ASSOCHAM National Council on Water addresses India's growing need for clean, safe and sustainable water solutions through public policy, technology and water-use efficiency.",
      "It advances its mission through a 4Ps framework — Policy, Programme, Public, and Platform — and was recognised as Winner of the Jal Sanchay Jal Bhagidari 1.0 Award for Best Industry Association.",
    ],
    leadership: [
      { name: "Mr Ajay Popat", role: "Chairman", designation: "Senior Advisor, Ion Exchange (India) Limited", initials: getInitials("Mr Ajay Popat"), photo: "" },
      { name: "Mr Siddharth K Desai", role: "Co-Chairman", designation: "Managing Director, Kishor Pumps", initials: getInitials("Mr Siddharth K Desai"), photo: "" },
      { name: "Mr Turbaashu Bhattacharya", role: "Co-Chairman", designation: "Director, Roserve Enviro Private Limited", initials: getInitials("Mr Turbaashu Bhattacharya"), photo: "" },
    ],
    publications: [], pressReleases: [], pressCoverage: [],
    events: [
      { title: "World Water Week 2024", type: "past", tag: "Forum", date: "2024", place: "Stockholm / India engagement", text: "ASSOCHAM's participation and knowledge exchange on water stewardship and demand management.", highlight: "" },
      { title: "Jal Shakti Abhiyan: Catch the Rain 2024", type: "past", tag: "Campaign", date: "2024", place: "Pan-India", text: "Strategic collaborations for Jal Sanchay Jal Bhagidari under the Jal Shakti Abhiyan.", highlight: "" },
    ],
  },

  /* ============================= TOURISM ============================= */

  "travel-tourism-and-hospitality": {
    sectorGroup: "Tourism (including Religious & Adventure Tourism)",
    title: "Travel, Tourism and Hospitality Council",
    overview: [
      "The ASSOCHAM National Council on Travel, Tourism & Hospitality advances India's tourism economy through policy advocacy and stakeholder collaboration, aligned with Make in India, Ease of Doing Business, MSME Growth, Digital Economy, and Sustainability.",
      "It works with Central and State Tourism Ministries to strengthen domestic and inbound tourism, tourism-linked MSME growth, digital adoption, and sustainable practices across destinations, hotels and transport.",
    ],
    leadership: [
      { name: "Mohit Kabra", role: "Chair", designation: "Group Chief Operating Officer, Make My Trip", initials: getInitials("Mohit Kabra"), photo: "" },
    ],
    priorityAreas: [
      "Policy advocacy and ease of doing business for tourism and hospitality",
      "MSME enablement, digital adoption and skill development",
      "Sustainable destination development and green hospitality practices",
    ],
    publications: [], pressReleases: [], pressCoverage: [],
    events: [
      { title: "National Tourism Conclave", type: "forthcoming", tag: "Conclave", date: "30 September", place: "New Delhi", text: "Forthcoming flagship conclave of the Travel, Tourism and Hospitality Council, alongside thematic and regional conferences.", highlight: "" },
    ],
  },

  "branding-marketing": {
    sectorGroup: "Tourism (including Religious & Adventure Tourism)",
    title: "Branding & Marketing Council",
    overview: [
      "The ASSOCHAM Council on Branding & Marketing strengthens India's brand competitiveness, with focus on Make in India, Ease of Doing Business, MSME Growth, Digital Economy, and Sustainability.",
      "It enables dialogue among marketing leaders, policymakers and academia, and promotes responsible, ethical branding practices through advocacy and knowledge leadership.",
    ],
    leadership: [
      { name: "Gaurav Ramdev", role: "Chair", designation: "CMO (India and South Asia), Visa", initials: getInitials("Gaurav Ramdev"), photo: "" },
      { name: "Tarun Jha", role: "Co-Chair", designation: "SVP and Head (Marketing), JSW Steel Limited", initials: getInitials("Tarun Jha"), photo: "" },
      { name: "Rajat Abbi", role: "Co-Chair", designation: "Vice President, Marketing, Greater India, Schneider Electric", initials: getInitials("Rajat Abbi"), photo: "" },
    ],
    priorityAreas: [
      "Thought leadership with cross-industry collaboration and policy influence",
      "Celebrating future-ready marketeers by leveraging AI tools and concepts",
      "Honouring best practices in the sector",
    ],
    publications: [], pressReleases: [], pressCoverage: [],
    events: [
      { title: "National Branding and Marketing Conclave and Excellence Awards", type: "forthcoming", tag: "Awards", date: "Feb/March 2027", place: "To be announced", text: "Forthcoming flagship conclave and excellence awards of the Branding & Marketing Council.", highlight: "" },
    ],
  },

  /* ============================= REAL ESTATE & URBAN DEVELOPMENT ============================= */

  "real-estate-housing-and-urban-development": {
    sectorGroup: "Real Estate & Urban Development",
    title: "Real Estate, Housing & Urban Development Council",
    overview: [
      "India's urban population is projected to reach 600 million by 2031, and the current housing deficit stands at approximately 19 million units, nearly 95% within the EWS and LIG categories.",
      "The ASSOCHAM Real Estate Council brings together government, industry, financial institutions and developers to promote regulatory reforms and collaborative solutions for housing and urban development, in support of the vision of Housing for All.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Pradeep Aggarwal", designation: "Founder & Chairman, Signature Global (India) Ltd", photo: "" },
      [{ name: "Mr. Vineet Kanwar", designation: "Director & Chief Executive (Corporate Affairs), DLF Limited", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "public-procurement": {
    sectorGroup: "Real Estate & Urban Development",
    title: "Public Procurement Council",
    overview: [
      "Public procurement accounts for a significant share of government spending and is a key lever for Ease of Doing Business, transparency and MSME participation.",
      "The ASSOCHAM Public Procurement Council engages PSUs, ministries and public buyers to promote procurement-policy reform, wider market access for industry, and greater transparency across the government procurement ecosystem.",
    ],
    leadership: buildLeadership(
      { name: "Dr. A K Agarwal", designation: "CMD, River Engineering Pvt Ltd", photo: "" },
      [{ name: "Mr. TK Mishra", designation: "Former Adviser, Coal India", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "sez-and-industrial-zones": {
    sectorGroup: "Real Estate & Urban Development",
    title: "SEZ and Industrial Zones Council",
    overview: [
      "India has over 240 operational SEZs spanning roughly 40,000 hectares of developed infrastructure, with around 22,000 hectares of land available for future development — playing a significant role in export promotion, investment generation and employment creation.",
      "The ASSOCHAM National Council on SEZs, Industrial Parks & Warehousing works with Central and State Governments on policy, regulatory reforms and investment linkages that support Make in India and long-term growth.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Ravinder Sannaredy", designation: "CMD, SriCity Pvt Ltd", photo: "" },
      [
        { name: "Dr. LB Singhal", designation: "Former Development Commissioner, Noida SEZ", photo: "" },
        { name: "Mr. Hitender Mehta", designation: "Partner, Centrum Legal", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= MANUFACTURING ============================= */

  "manufacturing-capital-goods": {
    sectorGroup: "Manufacturing",
    title: "Manufacturing & Capital Goods Council",
    overview: [
      "The ASSOCHAM National Council on Manufacturing & Capital Goods fosters engagement between government, industry and sectoral associations to support the growth of Manufacturing India.",
      "The Council organises conferences, round-tables and industry surveys, and advocates policy measures that contribute to infrastructure development and manufacturing growth.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Vinod Pandey", designation: "Director - Government and External Affairs, BMW Group India", photo: "" },
      [{ name: "Ms. Aditi Sharma", designation: "CMEO, Uno Minda Limited", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "textile-technical-textile": {
    sectorGroup: "Manufacturing",
    title: "Textile & Technical Textile Council",
    overview: [
      "India's textile and technical textile industry is a major contributor to manufacturing output, exports and employment, spanning traditional textiles through to technical and industrial applications.",
      "The ASSOCHAM Textile & Technical Textile Council brings together manufacturers, exporters and policymakers to advance the sector's competitiveness, support PLI-linked capacity growth in technical textiles, and strengthen India's position in global textile trade.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Updeep Singh Chatrath", designation: "CEO & Resident Director, Welspun Group", photo: "" },
      [{ name: "Mr. Anjani Prasad", designation: "Managing Director & Member of Global Leadership team, India, Nepal, Sri Lanka, Archroma India Private Limited", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "toy-council": {
    sectorGroup: "Manufacturing",
    title: "Toy Council",
    overview: [],
    // overview: PLACEHOLDER_OVERVIEW("Toy Council"),
    leadership: [],
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "chemical-petrochemicals": {
    sectorGroup: "Manufacturing",
    title: "Chemical & Petrochemical Council",
    overview: [
      "India's chemical industry is among the world's most diversified, comprising more than 80,000 commercial products and valued at approximately US$300 billion — nearly 7% of the economy.",
      "The ASSOCHAM National Council on Chemical & Petrochemicals promotes regulatory reforms, sustainable development and business competitiveness, working with Central and State Governments to accelerate sector growth.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Sagar Kaushik", designation: "President, Corporate & Industry Affairs, UPL Ltd", photo: "" },
      [
        { name: "Mr. Nilesh Kulkarni", designation: "Director - Commercial, Gharda Chemicals", photo: "" },
        { name: "Mr. Kapil Malhotra", designation: "Global Business Unit Head - Fluorochemicals, GFL", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "eodb-council": {
    sectorGroup: "Manufacturing",
    title: "EODB Council",
    overview: [
      "Ease of Doing Business reforms remain central to unlocking investment, reducing compliance burden and improving India's competitiveness for enterprises of every size.",
      "The ASSOCHAM EODB Council works with government bodies on land, labour and regulatory simplification, and channels ASSOCHAM's research into policy inputs that support MSME credit access, compliance simplification and digital-infrastructure reforms.",
    ],
    leadership: buildLeadership(
      { name: "Mrs. Sushma Paul Berlia", designation: "Chairman, Apeejay Stya and Svran Group", photo: "" },
      [{ name: "Mr. Ramachandran Venkataraman", designation: "Director & Chief Operating Officer, V Guard Industries Ltd", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "hr-ir-policies-and-reforms": {
    sectorGroup: "Manufacturing",
    title: "HR & IR Policies and Reforms Council",
    overview: [
      "Evolving labour codes and workforce policy are reshaping how Indian industry manages human resources and industrial relations.",
      "The ASSOCHAM Council on HR & IR Policies and Reforms brings together industry HR and IR leaders to engage government and international bodies on labour-code implementation, workforce-policy reform and practical compliance support for employers.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Manoj Sharma", designation: "Group Head - IR&HR, Adani Group", photo: "" },
      [{ name: "Mr. Anadi Sinha", designation: "Director - Group Corporate Affairs, Uno Minda Limited", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "defence-aerospace": {
    sectorGroup: "Manufacturing",
    title: "Defence & Aerospace Council",
    overview: [
      "India's defence and aerospace sector is central to the Atmanirbhar Bharat mission, with rising indigenisation, exports and private-sector participation across the value chain.",
      "The ASSOCHAM Defence & Aerospace Council engages the Ministry of Defence, DRDO, DPSUs and armed forces on procurement reforms, indigenisation, export promotion and offset policy to support a globally competitive Indian defence-manufacturing base.",
    ],
    // NOTE: master sheet lists the Co-Chair seat as "TBC" — add once confirmed.
    leadership: buildLeadership(
      { name: "Mr. Rajiv Gupta", designation: "Chief of Operations, Aerospace & Defence, Trucks, Buses and Construction Equipment, Mahindra Defence", photo: "" }
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= MINES & MINERALS ============================= */

  "mines-minerals": {
    sectorGroup: "Mines & Minerals (including Rare Earth, Iron & Steel)",
    title: "Mines & Minerals Council",
    overview: [
      "India is home to 1,531 operating mines and produces 95 minerals, including 4 fuel, 10 metallic, 23 non-metallic, 3 atomic, and 55 minor minerals — vital to infrastructure, manufacturing and energy security.",
      "The ASSOCHAM National Council on Mines & Minerals addresses national and global sectoral issues, working with Government and regulators to advance policy and sustainable mining practices under Make in India and the National Mineral Policy 2019.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Sauvick Mazumder", designation: "COO - Mining, JSW Steel Ltd", photo: "" },
      [{ name: "Capt. Rudra Sen Sindhu", designation: "Chairman & Managing Director, ACB Ltd", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "iron-steel": {
    sectorGroup: "Mines & Minerals (including Rare Earth, Iron & Steel)",
    title: "Iron & Steel Council",
    overview: [
      "Iron and steel remain foundational to India's infrastructure, manufacturing and construction sectors, underpinning the country's industrial growth ambitions.",
      "The ASSOCHAM Iron & Steel Council brings together producers and policymakers to advance sectoral competitiveness, raw-material availability and trade policy, supporting India's position among the world's largest steel producers.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Arun Maheshwari", designation: "Director - Commercial & Marketing, JSW Steel Limited", photo: "" },
      [
        { name: "Mr. Sanjay Kumar Singh", designation: "Director - External Affairs, Jindal Steel & Ex Steel Secretary", photo: "" },
        { name: "Mr. Ranjan Dhar", designation: "Director & VP-Sales & Marketing, AM/NS India Ltd", photo: "" },
      ]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= INTERNATIONAL AFFAIRS ============================= */

  "exports-trade": {
    sectorGroup: "International Affairs",
    title: "Exports & Trade Council",
    overview: [
      "With merchandise and services exports together forming a substantial share of India's GDP, expanding and diversifying India's trade footprint remains a national economic priority.",
      "The ASSOCHAM Exports & Trade Council works with the Ministry of Commerce and industry to open new markets, strengthen FTA utilisation, support MSME integration into export value chains, and address on-ground trade and logistics bottlenecks.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Ravi Gupta", designation: "Executive Director, Shree Renuka Sugars Limited", photo: "" },
      [{ name: "Mr. Sheetal Arora", designation: "CEO & Whole-Time Director, Mankind Pharma Ltd.", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "business-through-diplomacy": {
    sectorGroup: "International Affairs",
    title: "Business through Diplomacy Council",
    overview: [
      "Economic diplomacy plays a growing role in opening new markets, attracting investment and building institutional trust between India and its global partners.",
      "The ASSOCHAM Business through Diplomacy Council works with diplomatic missions and trade bodies to connect Indian industry with international opportunities and strengthen India's economic-diplomacy outreach.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Ashish Saraf", designation: "Consul, Commonwealth of Bahamas & Maldives in India", photo: "" }
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "africa-business-council": {
    sectorGroup: "International Affairs",
    title: "Africa Business Council",
    overview: [
      "Africa represents one of India's fastest-growing trade and investment corridors, with strong complementarities across manufacturing, agriculture, energy and infrastructure.",
      "The ASSOCHAM Africa Business Council connects Indian industry with African markets and institutions, promoting trade facilitation, investment linkages and business partnerships across the continent.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Sanjeev Sardana", designation: "Managing Director, Yamuna Power & Infrastructure Ltd.", photo: "" },
      [{ name: "Mr. Ramesh Mutha", designation: "Managing Director, Mohan Mutha Exports", photo: "" }]
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "bimstec": {
    sectorGroup: "International Affairs",
    title: "BIMSTEC Council",
    overview: [
      "The Bay of Bengal Initiative for Multi-Sectoral Technical and Economic Cooperation (BIMSTEC) connects South and Southeast Asian economies through trade, connectivity and investment cooperation.",
      "The ASSOCHAM BIMSTEC Council promotes business engagement and trade facilitation among member states, supporting Indian industry's regional integration and market access across the BIMSTEC region.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Tribhuvan Darbari", designation: "Resident Director/Chief Executive, Adventz/Texmaco Rail & Engineering Ltd", photo: "" }
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  "eurasia": {
    sectorGroup: "International Affairs",
    title: "Eurasia Council",
    overview: [
      "The Eurasian region offers Indian industry emerging opportunities across trade, energy and connectivity, particularly through frameworks like the International North-South Transport Corridor.",
      "The ASSOCHAM Eurasia Council works to strengthen trade and investment linkages between India and Eurasian economies, supporting Indian businesses seeking to expand into the region.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Tribhuvan Darbari", designation: "Resident Director/Chief Executive, Adventz/Texmaco Rail & Engineering Ltd", photo: "" }
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },

  /* ============================= STARTUPS ============================= */

  "startup": {
    sectorGroup: "Startups",
    title: "Startup Council",
    overview: [
      "India's startup ecosystem has become one of the largest in the world, spanning technology, fintech, deep-tech and consumer sectors.",
      "The ASSOCHAM Startup Council connects founders, investors and policymakers to strengthen the startup ecosystem through funding access, mentorship, policy advocacy and global market linkages.",
    ],
    leadership: buildLeadership(
      { name: "Mr. Arpit Agarwal", designation: "Partner, Blume Ventures", photo: "" }
    ),
    publications: [], pressReleases: [], pressCoverage: [], events: [],
  },
};

/* Convenience getter used by SectorsPage */
export function getSector(slug) {
  return SECTORS[slug] || null;
}